import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'core/common/hooks';
import { FunnelConfig } from '../entities';
import { updateConfig } from '../store/actions';
import { getFunnelConfig } from '../store/selectors';

export const useFunnelConfig = (funnelConfig: FunnelConfig | null) => {
  const dispatch = useDispatch();
  const storedFunnelConfig = useSelector(getFunnelConfig);

  useEffect(() => {
    if (!funnelConfig) return;

    dispatch(updateConfig(funnelConfig));
  }, [dispatch, funnelConfig]);

  return {
    config: funnelConfig ?? storedFunnelConfig.config,
  };
};
